import Image from 'next/legacy/image';

import { H2, H3 } from '@common/headline';

import Karen from '@public/img/how-it-works/Karen.png';
import Anne from '@public/img/how-it-works/Anne.png';
import AnneSmall from '@public/img/how-it-works/Anne-small.png';
import Carla from '@public/img/how-it-works/Carla.png';

export const SupportIsAlwaysAvailable = (): JSX.Element => (
  <div className="mt-[62px] flex flex-col text-blue lg:container lg:m-auto lg:flex-row">
    <div className="mx-3 lg:hidden">
      <H3>
        “Support is always available from your coach and the rest of the members
        in the group”
        <br />- <span className="text-purple">Rosie McCough</span>
      </H3>
      <div className="mt-[26px] flex">
        <div className="w-[70%]">
          <Image src={Karen} width={1614} height={1539} alt="Karen" />
        </div>
        <div className="flex w-[30%] flex-col pl-6">
          <div className="h-2/5" />
          <div className="h-3/5">
            <Image
              src={AnneSmall}
              width={210}
              height={201}
              objectFit="cover"
              alt="Anne"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="hidden lg:block">
      <div className="mt-[36px] flex">
        <div className="w-[40%]">
          <Image src={Karen} width={1614} height={1539} alt="Karen" />
        </div>
        <div className="mt-[8%] w-[26%] pl-6">
          <Image src={Anne} width={624} height={598} alt="Anne" />
        </div>
        <div className="mt-[18%] w-[34%] pl-6">
          <Image src={Carla} width={1272} height={1215} alt="Carla" />
        </div>
      </div>
      <div className="mt-[-42px] max-w-[66%]">
        <H2>
          “Support is always available from your coach and the rest of the
          members in the group”
          <br />- <span className="text-purple">Rosie McCough</span>
        </H2>
      </div>
    </div>
  </div>
);
